import { FC } from "react";
import {
    Grid,
    GridItem,
    Heading,
    Text,
} from "@smile2impress/components/relaunch";

import { ListItem } from "./components/ListItem";
import { TwoColumnListProps } from "./TwoColumnList.types";

export const TwoColumnList: FC<TwoColumnListProps> = ({
    content: {
        title,
        subtitle,
        items,
        withMobileList = false,
        singleColumnOnMobile = false,
    },
    headingAs,
}) => {
    return (
        <Grid
            gridTemplateColumns={["1fr", "1fr", "repeat(24, 1fr)"]}
            gridColumnGap={["initial", "initial", 2]}
        >
            <GridItem
                colStart={["auto", "auto", 2]}
                colSpan={["auto", "auto", 10]}
                mb={[3, 3, 0]}
            >
                <Heading as={headingAs} textStyle="title1" color="text.base">
                    {title}
                </Heading>
                {!!subtitle && (
                    <Text textStyle="body" color="text.base" mt={[0.7, 0.7, 1]}>
                        {subtitle}
                    </Text>
                )}
            </GridItem>
            <GridItem
                colStart={["auto", "auto", 12]}
                colSpan={["auto", "auto", 11]}
            >
                <Grid
                    maxW="100%"
                    gridTemplateColumns={
                        singleColumnOnMobile
                            ? ["1fr", "1fr", "repeat(2, 312px)"]
                            : withMobileList
                            ? ["1fr", "1fr", "repeat(2, 1fr)"]
                            : ["repeat(2, minmax(0, 1fr))"]
                    }
                    gridColumnGap={
                        singleColumnOnMobile
                            ? withMobileList
                                ? [3, 3, 4]
                                : [2, 2, 5.5]
                            : withMobileList
                            ? [3, 3, 4]
                            : [2, 2, 4]
                    }
                    gridRowGap={singleColumnOnMobile ? [3, 3, 5.5] : [3, 3, 4]}
                >
                    {items.map(
                        (item, index) =>
                            !!item?.title && (
                                <GridItem key={index}>
                                    <ListItem
                                        {...item}
                                        iconOnTop={!withMobileList}
                                    />
                                </GridItem>
                            )
                    )}
                </Grid>
            </GridItem>
        </Grid>
    );
};
